import React, {Component} from 'react'
import {observer} from 'mobx-react'

import ProfileDocumentComponent from './profile_document/ProfileDocumentComponent'
import ProfileSettingsComponent from './profile_settings/ProfileSettingsComponent'
import ProfileSaveAndExportComponent from './profile_save_and_export/ProfileSaveAndExportComponent'

import Icon from 'lib/struct/icon/Icon';

@observer export default class ProfileComponent extends Component {
    render() {
        /** @type {ProfileSettingsContext} */
        const context = this.props.context

        if (!context.with_profile) {
            // по-идее, не должны сюда попасть. но на всякий случай...
            return (
                <div>
                    <Icon name="loading"/>
                </div>
            )
        }

        return (
            <div>
                <ProfileDocumentComponent context={context}/>
                <ProfileSettingsComponent context={context}/>
                <ProfileSaveAndExportComponent context={context}/>
            </div>
        )
    }
}